/**
 * Registers the 'asfTabset' directive with the given module.
 * This directive is used to create a tabset component with various configurable options.
 * 
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */

import IBTabsetController from './IBTabsetController';

export default function registerAsfTabsetDirective(module) {

    module.directive('asfTabset', ['$routeParams', '$config', function ($routeParams, $config) {
        return {
            restrict: 'EA', // Restricts the directive to elements and attributes.
            scope: {
                contentObj: "=", // Two-way binding for the content object.
                rowKey: "=", // Two-way binding for the row key.
                containerKey: "=", // Two-way binding for the container key.
                colKey: "=", // Two-way binding for the column key.
                rows: "=", // Two-way binding for the rows.
                connectWith: "=", // Two-way binding for the connectWith option.
                sortableOption: "=", // Two-way binding for the sortable options.
                activeTab: '=', // Two-way binding for the active tab.
                isReadingTime: '=', // Two-way binding for the reading time flag.
                size: "=", // Two-way binding for the size.
                questionPart: "=" // Two-way binding for the question part.
            },
            /**
             * Determines the template URL based on configuration and mode.
             * @returns {string} The URL of the template to be used.
             */
            templateUrl: function () {
                if (!$config.isPreviewMode() && isCMS && !$config.isPDFMode()) {
                    return '/views/ib/components/tab/TabsetDirectiveCMS.html';
                }
                return '/views/ib/components/tab/TabsetDirective.html';
            },
            controller: IBTabsetController        
        };
    }]);
}